import React, { useMemo } from 'react'
import {
  selectCrossClientFilter,
  selectCrossClientFilteredResults,
  selectCrossClientResults,
  setCrossClientResultsMatchFilter,
} from '../../../../store/crossClient/crossClientResults'
import { CrossClientQueryResultMatch, CrossClientQueryResultMatches } from '../../../../models/CrossClient'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { MultiSelectDropdown, MultiSelectOption } from '../../../../components/MultiSelectDropdown/MultiSelectDropdown'
import './CrossClientFilter.scss'

const SELECT_OPTIONS: MultiSelectOption[] = [
  { id: CrossClientQueryResultMatches.MATCH, label: 'Matches' },
  { label: "Don't match", id: CrossClientQueryResultMatches.NO_MATCH },
]

export const CrossClientMatchFilter = () => {
  const dispatch = useAppDispatch()

  const results = useAppSelector(selectCrossClientResults)
  const filter = useAppSelector(selectCrossClientFilter).matches

  const matchingResults = useMemo(() => results.filter((r) => r.match === CrossClientQueryResultMatches.MATCH).length, [results])
  const notMatchingResults = results.length - matchingResults

  const handleOptionSelected = (selectedIds: string[]) => {
    dispatch(setCrossClientResultsMatchFilter(selectedIds as CrossClientQueryResultMatch[]))
  }

  const title =
    filter.length === 2
      ? `All results (${results.length})`
      : !filter.length
        ? 'Select an option'
        : filter[0] === CrossClientQueryResultMatches.MATCH
          ? `Matches (${matchingResults})`
          : `Don't match (${notMatchingResults})`

  return (
    <div>
      <MultiSelectDropdown
        name='cross-client-multi-select-dropdown'
        className='cross-client-match-filter-dropdown'
        options={SELECT_OPTIONS}
        onSelectedChanged={handleOptionSelected}
        initialSelectedOptions={filter}
        TitleComponent={
          <div className='d-flex gap-2'>
            <i className='bi bi-filter fs-6' />
            {title}
          </div>
        }
        changeOnClose={false}
      />
    </div>
  )
}
